if (!customElements.get('restock-notify')) {
  customElements.define(
    'restock-notify',
    class RestockNotify extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.moveBelowVariantPicker();
        this.sortSizeOptions();

        if (this.classList.contains('hidden')) {
          this.productInfo?.classList.remove('pf-restock-active');
          return;
        }

        this.productInfo?.classList.add('pf-restock-active');
        this.form = this.querySelector('form');
        this.storageKey = `pf-restock-notify:${this.dataset.productId}:${this.dataset.variantId}`;

        if (this.form && this.wasSubmitted()) {
          this.showSuccess();
          return;
        }

        this.form?.addEventListener('submit', this.rememberSubmission);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.rememberSubmission);
        if (this.productInfo && !this.productInfo.querySelector('restock-notify:not(.hidden)')) {
          this.productInfo.classList.remove('pf-restock-active');
        }
      }

      rememberSubmission = () => {
        try {
          localStorage.setItem(this.storageKey, 'true');
        } catch (error) {
          // The native Shopify form still submits if browser storage is unavailable.
        }
      };

      moveBelowVariantPicker() {
        if (this.classList.contains('hidden')) return;

        const picker = this.closest('product-info')?.querySelector('variant-selects');
        if (picker && picker.nextElementSibling !== this) picker.insertAdjacentElement('afterend', this);
      }

      sortSizeOptions() {
        const picker = this.closest('product-info')?.querySelector('variant-selects');
        const fieldsets = picker?.querySelectorAll('.product-form__input--pill') || [];

        fieldsets.forEach((fieldset) => {
          const firstInput = fieldset.querySelector('input[type="radio"]');
          if (!firstInput || !/(size|volume|ml)/i.test(firstInput.dataset.optionName || '')) return;

          const options = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input) => ({
            input,
            label: fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`),
            number: Number.parseFloat(input.value),
          }));

          if (options.some(({ label, number }) => !label || Number.isNaN(number))) return;

          options
            .sort((a, b) => a.number - b.number)
            .forEach(({ input, label }) => fieldset.append(input, label));
        });
      }

      wasSubmitted() {
        try {
          return localStorage.getItem(this.storageKey) === 'true';
        } catch (error) {
          return false;
        }
      }

      showSuccess() {
        if (!this.form) return;

        this.form.innerHTML = `
          <div class="pf-restock-notify__success" tabindex="-1">
            <span class="svg-wrapper" aria-hidden="true">
              <svg viewBox="0 0 14 10" fill="none">
                <path d="M1 5L5 9L13 1" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </span>
            <div>
              <strong>${this.escapeHtml(this.dataset.successTitle)}</strong>
              <p>${this.escapeHtml(this.dataset.successText)}</p>
            </div>
          </div>
        `;
        this.form.querySelector('.pf-restock-notify__success')?.focus();
      }

      escapeHtml(value = '') {
        const element = document.createElement('div');
        element.textContent = value;
        return element.innerHTML;
      }
    }
  );
}
